export default __webpack_public_path__ + "static/media/PD_login.0c82422a.svg";